/**
 * Last resort when the app never mounts.
 *
 * Deliberately imports nothing: if this file needed a module, the failure it exists to handle could
 * take that module with it. Built with `createElement`/`textContent` rather than `innerHTML` because
 * the reference is interpolated and error-derived text is never trusted markup.
 *
 * A blank white page is the worst outcome a user can get. This is the cheapest cure.
 */
export const renderBootstrapFailure = (reference: string): void => {
  try {
    const mount = document.getElementById('app') ?? document.body;
    if (!mount) {
      return;
    }
    mount.textContent = '';

    const wrap = document.createElement('div');
    wrap.setAttribute(
      'style',
      [
        'display:flex', 'flex-direction:column', 'align-items:center', 'justify-content:center',
        'min-height:100vh', 'padding:24px', 'text-align:center', 'gap:12px',
        'font-family:Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif',
        'color:#272a2e'
      ].join(';')
    );

    const title = document.createElement('h1');
    title.textContent = 'Studypages Data could not start';
    title.setAttribute('style', 'margin:0;font-size:24px');

    const body = document.createElement('p');
    body.textContent = 'Reloading usually fixes this. If it keeps happening, send us the reference below.';
    body.setAttribute('style', 'margin:0;font-size:14px;color:#6b7075;max-width:38ch');

    const ref = document.createElement('code');
    ref.textContent = `Reference: ${reference}`;
    ref.setAttribute('style', 'font-size:13px;color:#6b7075');

    const reload = document.createElement('button');
    reload.type = 'button';
    reload.textContent = 'Reload';
    reload.setAttribute(
      'style',
      'padding:9px 16px;border:1px solid rgba(0,0,0,.25);border-radius:4px;background:none;cursor:pointer;font-size:14px'
    );
    reload.addEventListener('click', () => window.location.reload());

    const mail = document.createElement('a');
    mail.href = `mailto:support@studypages.com?subject=${encodeURIComponent(`Studypages Data will not start (${reference})`)}`;
    mail.textContent = 'Email support';
    mail.setAttribute('style', 'font-size:13px;color:#6b7075');

    wrap.append(title, body, ref, reload, mail);
    mount.append(wrap);
  } catch {
    // Nothing left to try.
  }
};
